<template>
  <transition name="slide-fade">
    <aside
      class="sidebar absolute top-0 right-0 lg:relative lg:block z-50"
      :class="{ 'visible slide': isOpen, hidden: !isOpen }"
    >
      <ul class="sidebar-links">
        <li>
          <div class="profile-img">
            <Avatar
              :src="
                (this.userData || {}).photoUrl ? this.userData.photoUrl : ''
              "
              :username="(this.userData || {}).displayName || ''"
              :size="65"
            ></Avatar>
          </div>
        </li>
        <li v-for="(link, id) in links" :key="id" @click="closeSidebar">
          <router-link :to="link.url" v-if="link.url">
            <i :class="'icon bx ' + link.icon"></i>
            <span>{{ link.name }}</span>
          </router-link>
          <button
            v-if="link.operation == 'logout'"
            class="custom-sidemenu"
            @click="logout(link.type)"
          >
            <i :class="'icon bx ' + link.icon"></i>
            <span>{{ link.name }}</span>
          </button>
          <button
            v-if="link.operation == 'openChatWidget'"
            class="custom-sidemenu"
            @click="openChatWidget()"
          >
            <i :class="'icon bx ' + link.icon"></i>
            <span>{{ link.name }}</span>
          </button>
        </li>
      </ul>
    </aside>
  </transition>
</template>

<script>
import "boxicons";
import { mapGetters } from "vuex";
import Auth from "@/providers/auth";
import Avatar from "vue-avatar";
import firebase from "firebase";

export default {
  name: "Sidebar",
  props: {
    links: {
      type: Array,
      required: true
    }
  },
  components: {
    Avatar
  },
  computed: {
    ...mapGetters(["isOpen"])
  },
  mounted() {
    let user = firebase.auth().currentUser;
    firebase
      .database()
      .ref(`users/${user.uid}`)
      .on("value", snapshot => {
        this.userData = snapshot.val();
      });
  },
  methods: {
    closeSidebar() {
      return this.$store.commit("SETSIDEBAR", false);
    },
    logout(type) {
      Auth.signOut(this.$router, type)
        .then(() => {})
        .catch(err => {
          console.log("err occured", err);
        });
    },
    openChatWidget() {
      if (window.Tawk_API) {
        window.Tawk_API.showWidget();
        window.Tawk_API.maximize();
      }
    }
  },
  data() {
    return {
      userData: null
    };
  }
};
</script>

<style lang="postcss" scoped>
aside.sidebar {
  background: #595959;
  overflow: hidden;
  min-width: 180px;
  width: 180px;
  flex-grow: 0;
  @apply ml-auto h-screen py-5 pt-20;
}
.profile-img {
  width: 100% !important;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  /* @apply bg-gray-500 rounded-full h-10 w-10 mx-auto overflow-hidden; */
}
.sidebar-links {
  @apply h-full flex flex-col;
}
.sidebar-links li:first-of-type {
  @apply mb-5;
}
.sidebar-links li:last-of-type {
  @apply mt-auto;
}
.sidebar-links li a,
.custom-sidemenu {
  width: 100%;
  overflow-wrap: break-word;
  @apply text-white leading-none outline-none my-3 block p-1 pb-2 text-center font-medium rounded-sm;
}
.sidebar-links li a:hover,
.sidebar-links li .custom-sidemenu:hover,
.sidebar-links li a.is-active {
  transition: all ease-in-out 0.3s;
  @apply bg-custom bg-opacity-75;
}
.sidebar-links li span {
  @apply text-xs;
}
.sidebar-links li .icon {
  @apply block w-6 text-xl mx-auto text-center;
}

@screen lg {
  .profile-img {
    @apply h-16 w-16;
  }

  .sidebar-links li span {
    @apply block;
    font-size: 16px;
  }
  .sidebar-links li .icon {
    @apply block w-12 text-4xl mb-1;
  }
  aside.sidebar {
    min-width: 150px;
    width: 150px;
    @apply ml-auto h-screen py-5;
  }
}
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.custom-sidemenu:hover {
  cursor: pointer;
}
</style>
